import axios from 'axios';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../config/api';

const extractErrorMessage = (error) => {
  const payload = error?.response?.data;
  if (typeof payload?.message === 'string') return payload.message;
  if (typeof payload?.error === 'string') return payload.error;
  if (payload?.error && typeof payload.error?.message === 'string') return payload.error.message;
  if (typeof error?.message === 'string') return error.message;
  return 'An error occurred';
};

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    if (config.skipAuth) {
      return config;
    }

    const adminToken = localStorage.getItem('adminToken');
    const userToken = localStorage.getItem('token');

    const fullUrl = typeof config.url === 'string' ? config.url : '';
    const isAdminRoute = fullUrl.startsWith('/admin') || fullUrl.startsWith('admin');

    // Add admin token for admin routes
    if (isAdminRoute && adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    // Add user token for other routes if available
    else if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for success and error
apiClient.interceptors.response.use(
  (response) => {
    // Success toast - only for non-GET requests
    if (response.config.method !== 'get') {
      if (response.data && (response.data.message || response.data.success)) {
        const message = response.data.message || 'Operation completed successfully';
        toast.success(message, {
          autoClose: 1500,
          position: "top-right",
        });
      } else if (response.status >= 200 && response.status < 300) {
        // Generic success message if no specific message
        toast.success('Operation completed successfully', {
          autoClose: 1500,
          position: "top-right",
        });
      }
    }
    return response;
  },
  (error) => {
    // Error toast
    const errorMessage = extractErrorMessage(error);
    toast.error(errorMessage, {
      autoClose: 1500,
      position: "top-right",
    });
    return Promise.reject(error);
  }
);

export default apiClient;
